/* Utilities */
import { normalizeString } from 'js/utilities';

const SHOP_PREFIX = 'shop';

export function saveShopData(key, value) {
    try {
        const prefixedKey = `${SHOP_PREFIX}_${key}`;
        const serializedValue = JSON.stringify(value);
        sessionStorage.setItem(prefixedKey, serializedValue);
        return true;
    } catch (error) {
        return false;
    }
}

export function getShopData(key, defaultValue = null) {
    try {
        const prefixedKey = `${SHOP_PREFIX}_${key}`;
        const serializedValue = sessionStorage.getItem(prefixedKey);
        if (serializedValue === null) {
            return defaultValue;
        }
        return JSON.parse(serializedValue);
    } catch (error) {
        return defaultValue;
    }
}

export function getOriginalBrandName(normalizedBrand, vehicleMeta) {
    if (!normalizedBrand || !vehicleMeta?.brandsWithModels) return normalizedBrand;

    return Object.keys(vehicleMeta.brandsWithModels).find(
        brand => normalizeString(brand) === normalizedBrand
    ) || normalizedBrand;
}

export function getOriginalModelName(normalizedModel, normalizedBrand, vehicleMeta) {
    if (!normalizedModel || !normalizedBrand || !vehicleMeta?.brandsWithModels) return normalizedModel;

    const brandKey = Object.keys(vehicleMeta.brandsWithModels).find(
        brand => normalizeString(brand) === normalizedBrand
    );

    if (!brandKey || !vehicleMeta.brandsWithModels[brandKey]) return normalizedModel;

    return vehicleMeta.brandsWithModels[brandKey].find(
        model => normalizeString(model) === normalizedModel
    ) || normalizedModel;
}

export function saveVehicleFilterData(filters, vehicleMeta = {}, resetLicensePlate = false) {
    saveShopData('vehicleFilters', filters);

    if (resetLicensePlate) {
        saveShopData('licensePlate', '');
    }

    if (filters.brand) {
        const originalBrand = getOriginalBrandName(filters.brand, vehicleMeta);
        saveShopData('brandDisplay', originalBrand);
    }

    if (filters.model) {
        const originalModel = getOriginalModelName(filters.model, filters.brand, vehicleMeta);
        saveShopData('modelDisplay', originalModel);
    } else {
        saveShopData('modelDisplay', '');
    }
}

export function saveVehicleApiData(carData) {
    if (!carData) return;

    const filters = {
        ...(carData.brand ? { brand: normalizeString(carData.brand) } : {}),
        ...(carData.model ? { model: normalizeString(carData.model) } : {}),
        ...(carData.length ? { length: carData.length.toLowerCase() } : {}),
        ...(carData.height ? { height: carData.height.toLowerCase() } : {}),
        ...(carData.constructionYear ? { constructionYear: carData.constructionYear } : {}),
    };


    const existingFilters = getShopData('vehicleFilters', {});
    const updatedFilters = { ...existingFilters, ...filters };
    saveShopData('vehicleFilters', updatedFilters);

    if (carData.brand) {
        saveShopData('brandDisplay', carData.brand);
    }
    if (carData.model) {
        saveShopData('modelDisplay', carData.model);
    }

    return updatedFilters;
}
